import { render } from "./SelectLevelView.vue?vue&type=template&id=094e27f3"
import script from "./SelectLevelView.vue?vue&type=script&lang=js"
export * from "./SelectLevelView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__